export enum OptionName {
  uppercases = "uppercases",
  lowercases = "lowercases",
  numbers = "numbers",
  specialCharacters = "specialCharacters"
}
